import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import yuvapriyaDoc from '../../../../assets/images/Doctorsimages/dr.yuvapriya.png'
import favicon from "./../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'

const YuvapriyaDoc = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    document.title = "Dr. Yuvapriya P | Best Dentist, Aesthetic  Specialist in Bangalore & Bangalore";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Yuvapriya P (BDS, FMC), a trusted  dentist and aesthetic doctor in Bangalore & Bangalore. Expert in smile designing, root canal, skin pigmentation, acne, hair fall, and aesthetic with 4+ years of experience."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best dentist in Bangalore, female dentist in Bangalore, cosmetic dentist in Bangalore, root canal specialist in Bangalore, smile designing dentist in Bangalore, aesthetic doctor in Bangalore, skin and hair specialist in Bangalore, aesthetic doctor for hair fall in Bangalore, acne and pigmentation treatment in Bangalore, affordable dental treatment in Bangalore, dentist and aesthetics consultant near me, best aesthetic doctor in Bangalore, hair fall doctor in Bangalore"
      );
    }

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-yuvapriya-p-dentist-aesthetic-Bangalore-bangalore");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-yuvapriya-p-dentist-aesthetic-Bangalore-bangalore");
      document.head.appendChild(canonicalLink);
    }
    
    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');
  container.classList.add('veenadoc-pdf-mode');
  const originalStyles = new Map();
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });
  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }
  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });
  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const marginLeft = 10;
      const marginRight = 10; 
      const availableWidth = pdfWidth - marginLeft - marginRight;
      const scaleFactor = availableWidth / canvasWidth;
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.YUVAPRIYA_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
      container.classList.remove('veenadoc-pdf-mode');
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Yuvapriya P</span>
                  <span className="veenadoc-title-credentials">(BDS, FMC)</span>
                  <span className="veenadoc-title-location">Bangalore</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Recognised as one of the best  dentists in Bangalore and a trusted aesthetic  specialist in Bangalore. 
                    Combining the science of dentistry with the art of aesthetics and skin ,haircare. she provides holistic care for 
                    dental health, skin rejuvenation, and hair restoration with over 2 years of clinical experience.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
                    className="veenadoc-btn-primary-gradient"
                    onClick={() => navigate('/bookconsultation')}
                  >
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={yuvapriyaDoc} alt="Dr. Yuvapriya P – Consultant Dentist & Aesthetic Specialist in Bangalore and Bangalore" className="veenadoc-doctor-image" title='Dr. Yuvapriya P | Best Dentist  Doctor in Bangalore' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Yuvapriya P</h2>
                  <p>
                    Dr. Yuvapriya P (BDS, FMC) is a highly qualified Consultant Dentist and Aesthetic Specialist who combines 
                    the science of dentistry with the art of aesthetics to provide holistic care for her patients. 
                    With a strong educational foundation from Sathyabama Dental College and Hospital affiliated to DR.M.G.R Tamilnadu university chennai, and a Fellowship 
                    in Medical Cosmetology  in bangalore, she brings a rare and valuable blend of expertise in dental health, 
                    skin rejuvenation, and hair restoration.
                  </p>
                  <p>
                    Patients searching for the best dentist in Bangalore often turn to her for 
                    comprehensive treatments that address both oral health and overall appearance. Her professional journey includes 
                    working with renowned practices such as E Dental Clinic, chennai, and Latha Dental Clinic, Bangalore.
                  </p>
                </div>

                {/* Clinical Journey */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Journey & Professional Excellence</h2>
                  <p>
                    Her professional journey includes working with renowned practices where she treated patients across a wide 
                    range of dental and aesthetic needs. Over the years, she has built a reputation as a compassionate, precise, 
                    and skilled practitioner who ensures every patient receives individualized care.
                  </p>
                  <p>
                    Whether it is a routine dental check-up, a complex root canal, a smile makeover, or advanced cosmetic skin 
                    treatments, Dr. Yuvapriya has the expertise to deliver exceptional results. Patients often search for a 
                     dentist in Bangalore who is both gentle and effective, and Dr. Yuvapriya fits that role perfectly.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BDS, FMC</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">2+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Dentistry, Aesthetics </span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Locations:</span>
                      <span className="veenadoc-info-value">Bangalore</span>
                    </div>
                  </div>
                </div>


                <div className="veenadoc-article-block">
                  <h2>Specialized Haircare Solutions</h2>
                  <p>
                    Dr. Yuvapriya has gained recognition as a haircare doctor in Bangalore specializing in hair fall,dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy,Laser Hair reduction and qr678 to ensure effective and long-lasting results.
                  </p>
                  <p>
                    Her expertise ensures that patients not only regain healthy hair but also confidence and peace of mind.
                  </p>
                </div>

                {/* Dental Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Excellence in Dental Care</h2>
                  <p>
                    As a consultant dentist in Bangalore, she is known for her expertise in preventive dentistry, 
                    restorative care, cosmetic fillings, and smile designing, helping patients regain both oral health and 
                    confidence in their smiles. Her specialization in endodontics and restorative procedures allows her to be 
                    recognized as a trusted root canal specialist in Bangalore.
                  </p>
                  <p>
                    Patients struggling with tooth pain, infections, or damaged teeth often consult her for precise and lasting 
                    solutions. Beyond restoring function, she also ensures aesthetic results that look natural, which is why 
                    many consider her the best dentist for smile designing in Bangalore.
                  </p>
                </div>

                {/* Aesthetic Medicine */}
                <div className="veenadoc-article-block">
                  <h2>Leading Aesthetic Specialist</h2>
                  <p>
                   What makes Dr. Yuvapriya truly unique is her dual expertise in aesthetic care. Many patients searching for the best aesthetic doctor in Bangalore or a skilled skin and haircare specialist in Bangalore come across her profile because she offers advanced treatments for skin pigmentation, acne, pimples, anti-aging concerns, scars, and hair fall.
                  </p>
                  <p>
                    With her fellowship training, she uses safe, minimally invasive methods that focus on restoring natural 
                    beauty while supporting long-term health. In the field of cosmetology, she provides a wide range of services 
                    including pigmentation treatment, acne scar removal, anti-aging therapies, and skin rejuvenation procedures.
                  </p>
                </div>

                {/* Trichology Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Advanced Aesthetic Treatments</h2>
                  <p>
                    Her expertise extends to advanced aesthetic procedures including Hydrafacial treatment in Jayanagar Bangalore, 
                    chemical peels, and laser therapies. As patients search for aesthetic treatments in Jayanagar Bangalore, 
                    they often discover her reputation for offering safe, effective, and result-oriented cosmetic solutions.
                  </p>
                  <p>
                    She believes that external beauty is best preserved when internal health is maintained, which is why her 
                    aesthetic treatments are always supported by holistic health guidance .
                  </p>
                </div>

                {/* Holistic Approach */}
                <div className="veenadoc-article-block">
                  <h2>Holistic Healthcare Approach</h2>
                  <p>
                    Her approach is holistic—recognizing that oral health, skin health, and hair health are interconnected. 
                    She believes that a confident smile, glowing skin, and healthy hair all contribute to overall well-being. 
                    Patients who search for a dentist and aesthetics consultant near me often prefer her because they find a 
                    one-stop solution for dental care, skin treatments, and hair restoration.
                  </p>
                  <p>
                    This wide-ranging expertise makes her one of the most versatile and sought-after doctors in her field. 
                    For a patient struggling with tooth pain, she is the best dentist for root canal treatment in Bangalore. For 
                    someone wanting a brighter smile, she is a trusted cosmetic dentist in Bangalore.
                  </p>
                </div>

                {/* Patient Care Philosophy */}
                <div className="veenadoc-article-block">
                  <h2>Patient-Centered Care Philosophy</h2>
                  <p>
                   She ensures that every dental visit is a comfortable and positive experience by prioritizing patient comfort and clear, transparent communication. Her treatment  is built on empathy, ethics, and excellence. She believes that every patient deserves not only effective care but also a supportive and reassuring environment.
                  </p>
                  <p>
                    Patients frequently describe her as approachable, friendly, and deeply committed to their well-being. Many 
                    online reviews highlight her ability to explain treatment options clearly, her gentle handling of procedures, 
                    and the long-lasting results she provides.
                  </p>
                </div>

                {/* Online Presence & Patient Queries */}
                <div className="veenadoc-article-block">
                  <h2>Meeting Patient Needs Online</h2>
                  <p>
                    As online searches grow, patients increasingly look for various healthcare solutions. Dr. Yuvapriya's 
                    expertise matches many common search queries, ensuring that patients searching online can find her as a 
                    reliable and skilled practitioner:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li>Best dentist in Bangalore for comprehensive dental care</li>
                    
                    <li>Cosmetic dentist in Bangalore for smile designing</li>
                    <li>Root canal specialist in Bangalore for pain relief</li>
                    <li>Aesthetic doctor for skin pigmentation and acne treatment</li>
                    
                  </ul>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Yuvapriya P for Complete Care</h2>
                  <p>
                    Choosing Dr. Yuvapriya P means entrusting your dental, skin, and hair care to an experienced specialist 
                    who combines knowledge, technology, and compassion. Whether you are looking for a dentist in Bangalore for 
                    smile designing, an aesthetic doctor in Bangalore for anti-aging, or a aesthetic expert for hair fall 
                    in Bangalore, she is the right choice.
                  </p>
                  <p>
                    With her holistic and personalized approach, she ensures her patients achieve not only healthier teeth 
                    and skin but also renewed confidence and improved quality of life. Her dedication to affordable dental 
                    treatment in Bangalore and accessible aesthetic care in Bangalore has helped her build long-term trust among 
                    her patients.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To provide comprehensive healthcare that encompasses dental excellence, 
                    aesthetic enhancement, and hair restoration for complete patient wellness.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Combining dental excellence with aesthetic enhancement for complete patient wellness"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Yuvapriya P's Philosophy of Care</p>
                  </div>
                  <p>
                    She believes that true healthcare goes beyond treating individual symptoms and requires a comprehensive 
                    approach that addresses dental health, skin wellness, and hair care together. This patient-centric approach 
                    has positioned her among the most trusted multi-specialty doctors in Bangalore
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    {/* <div className="veenadoc-location-icon">📍</div> */}
                    {/* <div className="veenadoc-location-details">
                      <h4>Bangalore</h4>
                      <p>Primary dental & aesthetic practice</p>
                    </div> */}
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Bangalore</h4>
                      <p>Extended dental & aesthetic services</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience comprehensive dental, aesthetic, and hair care with Dr. Yuvapriya's personalized approach.</p>
                  <button
                    className="veenadoc-sidebar-btn-primary"
                    onClick={() => window.location.href = 'tel:+919964688333'}
                  >
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button
                    className="veenadoc-sidebar-btn-secondary"
                    onClick={() => window.location.href = 'tel:+919964688333'}
                  >
                    <span>💬</span>
                    <span>Get Free Assessment</span>
                  </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

        <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default YuvapriyaDoc
